// components/features/users/UsersList.tsx
import { User } from "@cabukaka/types";
import TableList, { SelectAction } from "../../ui/TableList";
import UserRow from "./UserRow";

interface UsersListProps {
  users: User[];
  onAction: (user: User) => void;
  onSelectUsers?: (selectedUsers: User[]) => void;
  selectable?: boolean;
  selectActions?: SelectAction[];
}

export default function UsersList({
  users,
  onAction,
  onSelectUsers,
  selectable = false,
  selectActions
}: UsersListProps) {
  const columns = [
    { header: "Utilisateur", className: "w-2/5" },
    { header: "Rôle", className: "hidden sm:table-cell w-1/6" },
    { header: "Statut", className: "hidden sm:table-cell w-1/6" },
    { header: "Inscrit le", className: "hidden md:table-cell w-1/6" },
  ];

  return (
    <TableList
      items={users}
      columns={columns}
      getId={(user) => user.id}
      onAction={onAction}
      onSelectItems={onSelectUsers}
      selectable={selectable}
      emptyMessage="Aucun utilisateur trouvé"
      actionColumn={true}
      selectActions={selectActions}
      renderRow={(user, isSelected, onSelect) => (
        <UserRow
          key={user.id}
          user={user}
          onAction={onAction}
          onSelect={onSelect}
          isSelected={isSelected}
          selectable={selectable}
        />
      )}
    />
  );
}